type Props = {
  className: string
  description: string
  color: string
  img: string
}

const CardsWidget20 = ({className, description, color, img}: Props) => (
  <div
    className={`card card-flush bgi-no-repeat ${className}`}
    style={{
      backgroundColor: color,
      backgroundImage: `url('${img}')`,
      backgroundPosition: 'calc(100% - 10px) center',
      backgroundSize: '35% 70%',
    }}
  >
    <div className='card-header pt-5 px-3'>
      <div className='card-title d-flex flex-column w-150px'>
        <span className='text-dark pt-1 fw-semibold fs-2'>{description}</span>
      </div>
    </div>
    <div className='card-body d-flex align-items-end pt-0 px-3'>
      <div className='d-flex align-items-center flex-column mt-3 w-100'></div>
    </div>
  </div>
)
export {CardsWidget20}
